import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Header from '@/app/components/Header'
import TemplatesTable from '@/app/components/TemplatesTable'
import TemplateDetailPage from '@/app/components/TemplateDetailPage'
import { MainContext } from '@/app/context'

function Home() {
  return (
    <Header>
      <TemplatesTable />
    </Header>
  )
}

function TemplateDetail() {
  return (
    <Header>
      <TemplateDetailPage />
    </Header>
  )
}

export default function App() {
  return (
    <div className="w-full h-full">
      <MainContext>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/templates/:templateId" element={<TemplateDetail />} />
          </Routes>
        </BrowserRouter>
      </MainContext>
    </div>
  )
}